import { Spinner } from "@chakra-ui/react";

export default function Loader() {
  return (
    <>
      <Spinner
        display="flex"
        thickness="5px"
        speed="0.65s"
        emptyColor="gray.200"
        color="#473198"
        size="xl"
        marginX="auto"
      />
    </>
  );
}
